import cats from '@/api/categories'
const state = {
  inputCat: []
}

const mutations = {
  input (state, input) {
    state.inputCat = input
  }
}

const actions = {
  categoryInput({ commit }, category) {

    category = category.toLowerCase();

    switch (category) {
      case 'archetypen':
        cats.categoryInputArchetype().then((res) => {
          commit('input', res.data.sectionValues)
        })
        break

      case 'merken':
        cats.categoryInputBrands().then((res) => {
          commit('input', res.data.sectionValues)
        })
        break

      case 'duurzaamheid':
        cats.categoryInputSustainability().then((res) => {
          commit('input', res.data.sectionValues)
        })
        break

      case 'lifestyle':
        cats.categoryInputLifestyle().then((res) => {
          commit('input', res.data.sectionValues)
        })
        break

      case 'media':
        cats.categoryInputMedia().then((res) => {
          commit('input', res.data.sectionValues)
        })
        break

      case 'overtuigingsstrategieën':
        cats.categoryInputPersuasion().then((res) => {
          commit('input', res.data.sectionValues)
        })
        break

      case 'politiek':
        cats.categoryInputPolitics().then((res) => {
          commit('input', res.data.sectionValues)
        })
        break

      case 'onderstromen':
        cats.categoryInputUndercurrent().then((res) => {
          commit('input', res.data.sectionValues)
        })
        break

      case 'waardekaarten':
        cats.categoryInputValueCards().then((res) => {
          commit('input', res.data.sectionValues)
        })
        break

      case 'mentality':
        cats.categoryInputMentality().then((res) => {
          commit('input', res.data.sectionValues)
        })
        break

      case 'fintality':
        cats.categoryInputFintality().then((res) => {
          commit('input', res.data.sectionValues)
        })
        break

      case 'burgerschapsstijlen':
        cats.categoryInputBurgerschapsstijlen().then((res) => {
          commit('input', res.data.sectionValues)
        })
        break

      case 'shoppermentality':
        cats.categoryInputShopperMentality().then((res) => {
          commit('input', res.data.sectionValues)
        })
        break

      case 'vitality':
        cats.categoryInputVitality().then((res) => {
          commit('input', res.data.sectionValues)
        })
        break

      case 'zorgmentality':
        cats.categoryInputZorgMentality().then((res) => {
          commit('input', res.data.sectionValues)
        })
        break

      case 'vijftintengroener':
        cats.categoryInputVijfTintenGroener().then((res) => {
          commit('input', res.data.sectionValues)
        })
        break

      case 'vrijetijdsprofielen':
        cats.categoryInputVrijetijdsprofielen().then((res) => {
          commit('input', res.data.sectionValues)
        })
        break
    }
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
